import SegmentTracker from '../tracking/trackers/segmentTracker';

export const shutdownIntercom = (): void => {
  SegmentTracker.shutdownIntercom();
};

export const rebootIntercom = (): void => {
  SegmentTracker.rebootIntercom();
};
